export default "__VITE_ASSET__DBlVWzJH__"